import React, { useMemo } from 'react'
import { AppRoutes } from 'navigations/app-routes'
import HomeBookTimeslotPreviewScene from 'scenes/home/book/timeslots/preview'
import HomeBookSelectCoworkerIndexScene from 'scenes/home/book/coworker'
import HomeBookSelectCoworkerViewScene from 'scenes/home/book/coworker/view'
import HomeBookLocationScene from 'scenes/home/book/location'
import HomeBookTimeslotScene from 'scenes/home/book/timeslots'
import HomeBookLunchScene from 'scenes/home/book/lunch'
import HomeBookLicensePlateScene from 'scenes/home/book/license_plate'
import HomeBookValidateScene from 'scenes/home/book/validate'
import HomeBookFinishedScene from 'scenes/home/book/finished'
import { stackProps } from 'utils/helper-navigation'
import _ from 'lodash'
import HelperString from 'utils/helper-string'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import BookProvider, { useBookProvider } from 'scenes/home/book/_providers/BookProvider'
import { createPageTitle } from 'utils/helper-page-title'

const Stack = createNativeStackNavigator();

const HomeBookRoot = () => {
	return (
		<BookProvider>
			<HomeBookRootStack />
		</BookProvider>
	)
}

const HomeBookRootStack = () => {
	
	const { setRoute } = useBookProvider()
	
	const routes = useMemo( () => {
		return {
			//[ AppRoutes.ADD_BOOKING_OPTION ]: HomeBookStartScene,
			[ AppRoutes.ADD_BOOKING_PREVIEW ]: HomeBookTimeslotPreviewScene,
			[ AppRoutes.ADD_BOOKING_SELECT_COWORKER ]: HomeBookSelectCoworkerIndexScene,
			[ AppRoutes.ADD_BOOKING_VIEW_COWORKER ]: HomeBookSelectCoworkerViewScene,
			
			[ AppRoutes.ADD_BOOKING_LOCATION ]: HomeBookLocationScene,
			[ AppRoutes.ADD_BOOKING_LOCATION_2 ]: HomeBookLocationScene,
			[ AppRoutes.ADD_BOOKING_LOCATION_3 ]: HomeBookLocationScene,
			[ AppRoutes.ADD_BOOKING_DATE ]: HomeBookTimeslotScene,
			[ AppRoutes.ADD_BOOKING_LUNCH ]: HomeBookLunchScene,
			[ AppRoutes.ADD_BOOKING_LICENSE_PLATE ]: HomeBookLicensePlateScene,
			[ AppRoutes.ADD_BOOKING_OVERVIEW ]: HomeBookValidateScene,
			[ AppRoutes.ADD_BOOKING_SUCCESS ]: HomeBookFinishedScene,
		}
	}, [] )
	
	return (
		<Stack.Navigator
			{ ...stackProps }
			screenOptions={{
				...stackProps.screenOptions,
			}}
			screenListeners={ ({ navigation, route }) => {
				return (
					{
						focus: ( e ) => {
							setRoute( route )
						}
					}
				);
			}}>
			
			{ _.map( routes, ( route, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `BookingNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( route, 'title', null ) )
						}}
						component={ route }
					/>
				);
			})}
		</Stack.Navigator>
	)
}

export default HomeBookRoot
